import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.5 19h-5.5a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v3","key":"svg-0"}],["path",{"d":"M7 15h5","key":"svg-1"}],["path",{"d":"M17 12h-3","key":"svg-2"}],["path",{"d":"M11 12h-1","key":"svg-3"}],["path",{"d":"M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39","key":"svg-4"}]]

const IconSubtitlesEdit = createReactComponent('outline', 'subtitles-edit', 'SubtitlesEdit', __iconNode);

export default IconSubtitlesEdit;